// extracted by mini-css-extract-plugin
export default {"center":"NotFound_center__ohYEz","margin":"NotFound_margin__Gyl8Y"};